import { useGetAccessControlsQuery } from '../../../../__generated__/chirp/com/hubspot/ai/access/controls/rpc/AiAccessControlsChirpService.hooks';
export const useAiAccessControls = (options = {}) => {
  const {
    data,
    error,
    loading,
    refetch
  } = useGetAccessControlsQuery({
    onCompleted: response => {
      var _options$onCompleted;
      (_options$onCompleted = options.onCompleted) === null || _options$onCompleted === void 0 || _options$onCompleted.call(options, response.result);
    },
    onError: options.onError,
    skip: options.skip,
    useLegacyFieldNameMode: true
  });
  return {
    accessControls: data === null || data === void 0 ? void 0 : data.getAccessControls,
    error,
    loading,
    refetch
  };
};